import {
  type CollectionTypeEnum,
  usePaginatedSearchChildCollectionCandidatesQuery,
} from 'domains/collections/api'

interface UseSearchCollectionsArgs {
  retailerId: string
  collectionId?: string
  active?: boolean
  collectionName?: string
  collectionTypes: CollectionTypeEnum[]
}

export const useSearchChildCollectionCandidates = ({
  retailerId,
  collectionId,
  collectionTypes,
  active,
  collectionName,
}: UseSearchCollectionsArgs) => {
  const { apiResult, apiSuccess, loading, error, canLoadMore, loadMore, refetch } =
    usePaginatedSearchChildCollectionCandidatesQuery({
      variables: {
        retailerId,
        collectionId,
        collectionTypes,
        // TODO: remove comment when API support added
        // active,
        // collectionName,
      },
      fetchPolicy: 'cache-and-network',
    })

  return {
    collections: apiResult,
    apiSuccess,
    apiLoading: loading,
    apiError: error,
    canLoadMore,
    loadMore,
    refetch,
  }
}
